import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme, { selected }: { selected: boolean }) => ({
    checkbox: {
        display: "inline",

        ".mantine-Checkbox-input:checked": {
            backgroundColor: theme.colors.violet[5],

            "& + .mantine-Checkbox-icon": {
                color: theme.white,
            },
        },

        ".mantine-Checkbox-label": {
            color: selected ? theme.colors.violet[8] : "inherit",
        },
    },
}))
